import { replacePlaceholders } from "@lib/sharedUtils";
import { ReactElement } from "react";
import styles from "@components/shared/form/styles.module.scss";

interface PreFirstStepTitleProps {
    title: string;
    region: string | undefined;
    city: string | undefined;
}

export default function PreFirstStepTitle({
    title,
    region,
    city,
}: PreFirstStepTitleProps): ReactElement {
    return (
        <div className={styles["preStepTitle"]}>
            {replacePlaceholders(title, { region, city })}
        </div>
    );
}
